// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"336":"1bd7aa7f","417":"fbdc26ff"}[chunkId] + ".chunk.css";
};